define("settings/components/modal/form-footer", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if (has-block)}}
    {{yield}}
  {{else}}
    <button type="button" class="o--btn o--btn--outline u--float--left" data-test-id="cancel" onclick={{@cancel}}>
      {{if @cancelButtonText @cancelButtonText (t "shared_words.cancel")}}
    </button>
  
    <button type="submit" class="o--btn o--btn--primary u--float--right {{if (or @isDisabled  @isRunning) "o--btn--disabled"}}" data-test-id="save">
      {{#if (and @isRunning @runningText)}}
        {{ @runningText }}
      {{else}}
        {{if @submitButtonText @submitButtonText (t "shared_words.save")}}
      {{/if}}
    </button>
  {{/if}}
  
  */
  {
    "id": "NN0Ecjui",
    "block": "[[[41,[48,[30,7]],[[[1,\"  \"],[18,7,null],[1,\"\\n\"]],[]],[[[1,\"  \"],[10,\"button\"],[14,0,\"o--btn o--btn--outline u--float--left\"],[14,\"data-test-id\",\"cancel\"],[15,\"onclick\",[30,1]],[14,4,\"button\"],[12],[1,\"\\n    \"],[1,[52,[30,2],[30,2],[28,[37,3],[\"shared_words.cancel\"],null]]],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,\"button\"],[15,0,[29,[\"o--btn o--btn--primary u--float--right \",[52,[28,[37,4],[[30,3],[30,4]],null],\"o--btn--disabled\"]]]],[14,\"data-test-id\",\"save\"],[14,4,\"submit\"],[12],[1,\"\\n\"],[41,[28,[37,5],[[30,4],[30,5]],null],[[[1,\"      \"],[1,[30,5]],[1,\"\\n\"]],[]],[[[1,\"      \"],[1,[52,[30,6],[30,6],[28,[37,3],[\"shared_words.save\"],null]]],[1,\"\\n\"]],[]]],[1,\"  \"],[13],[1,\"\\n\"]],[]]]],[\"@cancel\",\"@cancelButtonText\",\"@isDisabled\",\"@isRunning\",\"@runningText\",\"@submitButtonText\",\"&default\"],false,[\"if\",\"has-block\",\"yield\",\"t\",\"or\",\"and\"]]",
    "moduleName": "settings/components/modal/form-footer.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});